<template>
  <div>
    <table class="hm">
      <tr>
        <th></th>
        <th v-for="c in cols" :key="c">{{ c }}</th>
      </tr>
      <tr v-for="row in shown" :key="row.name">
        <th class="hm-rowh">{{ row.name }}</th>
        <td
          v-for="(v, i) in row.values"
          :key="i"
          :style="cellStyle(v)"
          :title="`${row.name} · ${cols[i]}: ${fmt(v)}${typeof v === 'number' ? suffix : ''}`"
        >
          {{ fmt(v) }}{{ typeof v === "number" ? suffix : "" }}
        </td>
      </tr>
    </table>
    <button v-if="topN && rows.length > topN" class="hm-toggle" @click="expanded = !expanded">
      {{ expanded ? `▲ ย่อกลับ (แสดง ${topN} รายการ)` : `▼ แสดงทั้งหมด ${rows.length} รายการ` }}
    </button>
  </div>
</template>

<script>
import { numVal, fmtVal } from "@/utils/nhsoDashboardFormat";

export default {
  name: "HeatmapTable",
  props: {
    cols: { type: Array, required: true },
    rows: { type: Array, required: true }, // [{ name, values: (number|"<5")[] }]
    ramp: { type: Array, required: true }, // light -> dark
    suffix: { type: String, default: "" },
    topN: { type: Number, default: 0 }, // 0 = show all; else collapse with expand toggle
  },
  data() {
    return { expanded: false };
  },
  computed: {
    shown() {
      return !this.topN || this.expanded ? this.rows : this.rows.slice(0, this.topN);
    },
    maxVal() {
      return Math.max(1, ...this.rows.flatMap(r => r.values.map(numVal)));
    },
  },
  methods: {
    fmt: fmtVal,
    cellStyle(v) {
      const step = Math.min(
        this.ramp.length - 1,
        Math.floor((numVal(v) / this.maxVal) * this.ramp.length)
      );
      return {
        background: this.ramp[step],
        color: step >= Math.ceil(this.ramp.length / 2) ? "#fff" : "var(--nd-text)",
      };
    },
  },
};
</script>

<style scoped>
.hm {
  border-collapse: separate;
  border-spacing: 3px;
  width: 100%;
}
.hm th {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--nd-muted);
  padding: 3px 4px;
  text-align: center;
}
.hm .hm-rowh {
  text-align: right;
  white-space: nowrap;
}
.hm td {
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  padding: 9px 4px;
  font-variant-numeric: tabular-nums;
}
.hm-toggle {
  font-size: 12px;
  color: var(--nd-accent);
  background: none;
  border: 0;
  padding: 8px 0 0;
  cursor: pointer;
  font-weight: 600;
}
.hm-toggle:hover {
  text-decoration: underline;
}
</style>
